import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { constants } from 'src/app/constants';
import { GeneralService } from 'src/app/api/config/general.service';
import { ToolsService } from 'src/app/utils/tools.service';
import { HttpHeaders } from '@angular/common/http';
import { WarehouseService } from 'src/app/api/config/warehouse.service';
import { ServiceService } from 'src/app/api/catalog/service.service';
declare var $: any;

@Component({
  selector: 'app-service-form',
  templateUrl: './service-form.component.html',
  styleUrls: ['./service-form.component.css']
})
export class ServiceFormComponent implements OnInit {
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // variables
  imageUrl: any = null;
  fileUrlImage: any = null;
  // arrats values
  unitSelected: any = null;
  unitChildSelected: any = null;
  unitSelectedValue: any = null;
  type_products: any = constants.PRODUCT.TYPEPRODUCT;
  brands: any = [];
  lines: any = [];
  units: any = [];
  units_childs: any = [];
  typeprices: any = [];

  typeprice_general: any = constants.PRODUCT.TYPEPRICE[0].id;
  typeprice_unit: any = constants.PRODUCT.TYPEPRICE[1].id;

  price_general: any = {
    price_purchase: null,
    price_min: null,
    price_sale: null,
    price_credit: null,
    price_wholesaler: null
  };

  stock_general: any = {
    stock: 0,
    warehouse_id: null
  };

  unitprices: any = [];
  warehousesSelected: any = null;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private serviceService: ServiceService,
    private generalService: GeneralService,
    private warehouseService: WarehouseService,
    public toolsService: ToolsService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      type_product: [
        constants.PRODUCT.TYPEPRODUCT[1].id,
        [Validators.required]
      ],
      typeprice_id: [constants.PRODUCT.TYPEPRICE[0].id, [Validators.required]],
      brand_id: [null],
      line_id: [null],
      description: ['', [Validators.required, Validators.minLength(2)]],
      code: [null],
      comment: [null],
      price_sale: [null],
      is_show: [true],
      is_favorite: [false],
      is_control_stock: [false],
      is_limit_stock: [false],
      limit_stock: [null],
      is_control_expiration: [false],
      is_limit_expiration: [false],
      is_grouped: [false],
      limit_expiration: [null],
      url_image: [null]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.getUnits();
    this.getTypePrices();
    this.getWarehousePrincipal();
    this.navigationTrackerService.initializeMenu(this.route);
    (<any>$('[data-toggle="tooltip"]')).tooltip();
    if (this.isEdit) {
      this.editData();
    }

    setTimeout(() => {
      (<any>$('#type_product')).attr('disabled', true);
    }, 25);
  }

  editData() {
    this.serviceService.get(this.checkId).subscribe({
      next: (data: any) => {
        let result = data.data;
        console.log(result);
        this.item.patchValue({
          type_product: result.type_product,
          typeprice_id: result.typeprice_id,
          brand_id: result.brand_id,
          line_id: result.line_id,
          description: result.description,
          code: result.code,
          comment: result.comment,
          price_sale: result.price_sale,
          is_show: result.is_show,
          is_favorite: result.is_favorite,
          is_control_stock: result.is_control_stock,
          is_limit_stock: result.is_limit_stock,
          limit_stock: result.limit_stock,
          is_control_expiration: result.is_control_expiration,
          is_limit_expiration: result.is_limit_expiration,
          is_grouped: result.is_grouped,
          limit_expiration: result.limit_expiration,
          url_image: result.url_image
        });

        this.price_general = result.price_general;
        this.unitprices = result.unitprices;
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  getUnits() {
    this.generalService.listUnitmeasureParents().subscribe({
      next: (data: any) => {
        this.units = data.results;
        for(let i in this.units){
          if(this.units[i].is_service && this.units[i].is_principal){
            this.unitSelected = this.units[i].id;
            this.unitSelectedValue = this.units[i];            
          }
        }
        setTimeout(() => {
          (<any>$('#unitSelected')).val(this.unitSelected);
        }, 150);
        // this.getUnitChilds();
      }
    });
  }

  getUnitChilds() {
    this.generalService.getUnitmeasuresChilds(this.unitSelected).subscribe({
      next: (data: any) => {
        this.units_childs = data.results;
        this.unitChildSelected = this.units_childs[0].id;
      }
    });
  }

  getTypePrices() {
    this.generalService.listTypePrices().subscribe({
      next: (data: any) => {
        this.typeprices = data.results;
      }
    });
  }

  getWarehousePrincipal() {
    this.warehouseService.listPrincipal().subscribe({
      next: (data: any) => {
        this.warehousesSelected = data.results;
        this.stock_general.warehouse_id = data.results.id;
      }
    });
  }

  changeUnitSelected() {
    this.unitSelectedValue = this.toolsService.searchArrById(
      this.unitSelected,
      this.units
    );
    this.unitprices = [];
    if (this.item.value.typeprice_id == this.typeprice_unit) {
      this.getUnitChilds();
      this.unitprices.push(this.unitSelectedValue);
    }
  }

  changeTypePrice() {
    if (this.item.value.typeprice_id == this.typeprice_unit) {
      this.getUnitChilds();
      this.unitprices.push(this.unitSelectedValue);
    } else {
      this.unitprices = [];
    }
  }

  addUnitPrice() {
    let item_ = this.toolsService.searchArrById(
      this.unitChildSelected,
      this.units_childs
    );

    if (this.toolsService.notExistObjInArr(item_, this.unitprices)) {
      this.unitprices.push(item_);
    } else {
      this.alertifyMsg.warning(
        'La equivalencia ' + item_.description + ' ya se encuentra agregado'
      );
    }
  }

  changeUnitEquivalence(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.unitprices[index].equivalence = value_;
    }
  }

  changeUnitPrice(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.unitprices[index].price = value_;
    }
  }

  removeUnitPrice(index: any) {
    this.unitprices.splice(index, 1);
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (this.toolsService.validateSizeImg(file)) {
      this.fileUrlImage = event.target.files[0];
      this.previewImage(file);
    }
  }

  previewImage(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      this.imageUrl = reader.result as string;
      this.item.patchValue({
        url_image: null
      });
    };
    reader.readAsDataURL(file);
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }

    let data: any = {};

    if (this.validate()) {
      data.item = this.item.value;
      const formData = new FormData();
      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');
      formData.append('item', JSON.stringify(data));
      formData.append('unit_id', this.unitSelected);
      formData.append('price_general', JSON.stringify(this.price_general));
      formData.append('price_units', JSON.stringify(this.unitprices));
      formData.append('stock_general', JSON.stringify(this.stock_general));
      formData.append('url_image', this.fileUrlImage);

      if (this.isEdit) {
        formData.append('id', JSON.stringify(this.checkId));
        this.serviceService.updateSave(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.cancel();
          }
        });
      } else {
        this.serviceService.save(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.cancel();
          }
        });
      }
    }
  }

  validate() {
    if (_.isNull(this.price_general.price_sale)) {
      this.alertifyMsg.warning('El campo precio "PV. GENERAL" es obligatorio ');
      (<any>$('#price_sale')).focus();
      return false;
    }
    return true;
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/catalogo/servicios/lista']);
  }
}
